module.exports = __webpack_public_path__ + "static/img/sxsyTitle.34bd053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sxsyTitle.png
// module id = Qx0Z
// module chunks = 2